<template>
    <div class="col-12 row d-flex justify-content-center">
        <span class="col-12 ft11">
            Firmado en
            <span v-if="data.estado_cliente != 'JALISCO' && data.estado_cliente != 'CIUDAD DE MÉXICO'" v-bind:class="{ marca: data.showMarca }">
            {{ data.municipio_cliente }}, {{ data.estado_cliente }}
            el
            {{ data.fecha_contrato }}.
            </span>
            <span v-if="data.estado_cliente == 'JALISCO'"  v-bind:class="{ marca: data.showMarca }">
            GUADALAJARA, JALISCO
            el
            {{ data.fecha_contrato }}.
            </span>
            <span v-if="data.estado_cliente == 'CIUDAD DE MÉXICO' || data.estado_cliente == 'ESTADO DE MÉXICO'"   v-bind:class="{ marca: data.showMarca }">
            CIUDAD DE MÉXICO
            el
            {{ data.fecha_contrato }}.
            </span>
            <br /><br /><br />
            <span class="ft11">
              MANIFIESTO BAJO PROTESTA DE DECIR VERDAD QUE SOY UNA PERSONA SOLVENTE Y CUENTO CON RECURSOS PROPIOS PARA
              HACER FRENTE A ESTE ADEUDO.
            </span>
            <br /><br /><br />
        </span>

        <div v-if="data.tipoABasic" class="col-6 row pt-4 p-2 m-0">
            <br><br>
            <div class="col-12 border-top border-dark text-center">
                <span v-if="data.tipoABasic" class="ft11Black text-center">
                DEUDOR / SUSCRIPTOR
                </span>
                <br>
                <span v-if="data.tipoABasic" class="ft11 text-center">
                  {{ data.nombre_cliente }}        <br>
                </span>
                <span v-if="data.tipoAmoral" class="ft11Black text-center">
                  Representado por
                </span>
                <span v-if="data.tipoAmoral" class="ft11 text-center">
                  <br> {{data.reprecentante_legal  }}
                </span>
            </div>
        </div>
        <div v-if="data.tipoAendorsement" class="col-6 row pt-4 p-2 m-0">
            <br><br>
            <div class="col-12 border-top border-dark text-center">
                <span class="ft11Black">
                    AVAL Y OBLIGADO SOLIDARIO <br>
                </span>
                <span  class="ft11 text-justify">
                    {{ data.nombre_aval }}
                </span>
            </div>
        </div>
        <div v-if="data.tipoAbound" class=" col-6 row pt-4 p-2 m-0">
            <br><br>
            <div class="col-12 border-top border-dark text-center">
            <span class="ft11Black">
                AVAL Y OBLIGADO SOLIDARIO <br>
            </span>
            <span  class="ft11 text-justify">
                {{ data.nombre_obligado }}
            </span>
            </div>
        </div>
    </div>
</template>

  <script>


  export default {
    name: "firmasPagares",
    data() {
      return {};
    },
    validations() {
      return {};
    },
    props: {
      data: {
        type: Object
      }
    },
    methods: {

    },
    created() {

    }
  };
  </script>
  <style type="text/scss">
  @import "../style.scss";
  </style>



// WEBPACK FOOTER //
// src/views/contratoArrendamiento/pagare/firmasPagares.vue